import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AppLauncher } from "./shell/AppLauncher";
import { HelpCenter } from "./shell/help/HelpCenter";
import AvailabilityApp from "./apps/availability/AvailabilityApp";
import GearApp from "./apps/gear/GearApp";
import { AuthProvider } from "./apps/gear/lib/auth";

/* ─────────────── SARTELL SOCCER APPS — PLATFORM SHELL ───────────────
   "/" is the app selector. Each app owns a path prefix and everything under it.
   Adding an app: drop it in src/apps/<name>/, add a <Route path="<name>/*">
   here, and add a card in shell/AppLauncher.jsx.                            */

/* Legacy magic links were issued as /?t=<teamId>&code=<passcode> back when
   Availability WAS the whole site, and those QR codes are printed and in the
   wild — we can't recall them. "/" is now the launcher, so it has to hand any
   link carrying those params straight to Availability instead of swallowing
   them and showing a chooser to someone who scanned a team code. */
function RootRoute() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  if (params.get("t") && params.get("code")) {
    return <Navigate to={`/availability${location.search}`} replace />;
  }
  return <AppLauncher />;
}

export default function App() {
  return (
    <BrowserRouter>
      {/* Gear Exchange's auth context is mounted app-wide rather than inside
          GearApp so a signed-in session survives navigating out to the
          launcher and back. Availability keeps its own localStorage session
          and does not use this. */}
      <AuthProvider>
        <Routes>
          <Route path="/" element={<RootRoute />} />
          <Route path="/help" element={<HelpCenter />} />
          <Route path="/help/:section" element={<HelpCenter />} />
          <Route path="/availability/*" element={<AvailabilityApp />} />
          <Route path="/gear/*" element={<GearApp />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
